
<ag-grid-angular 
    style="width: 100%; min-height:400px; height: calc(100vh - 300px);" 
    class="ag-theme-balham"
    [columnDefs]="report.columnDefs"
    [rowData]="report.dataSubmissions"
    [gridOptions]="gridOptions">
</ag-grid-angular>
